import React, { useState } from 'react';
import { Add } from '@mui/icons-material';
import { Box, Button, Grid, Typography } from '@mui/material';
import { colors } from '../../assets/utils/colors';
import CustomCard2 from '../cards/CustomCard2';
import ProductBranchesTable from '../tables/ProductBranchesTable';
import AddBranchStock from '../../pages/products/AddBranchStock';
import CustomDialogy from '../dialogys/CustomDialogy';
import { numberWithCommas } from '../../utils/helpers';

// !############### MAIN FUNC ####################
const ProductDetailsSidebar = ({ product }) => {
    const [openDialogy, setOpenDialogy] = useState(false);

    const handleOpenDialogy = () => {
        setOpenDialogy(true);
    };
    const handleCloseDialogy = () => {
        setOpenDialogy(false);
    };

    const { product_details } = product;

    const inStockCount =
        product_details?.product_quantity - product_details?.product_sold;
    const soldCount = product_details?.product_sold;
    const totalSells = soldCount * product_details?.product_price;
    return (
        <>
            {/* ############# DIALOG ############### */}
            <CustomDialogy
                title={'Add product stock'}
                open={openDialogy}
                handleCloseDialogy={handleCloseDialogy}
            >
                <AddBranchStock />
            </CustomDialogy>

            {/* ################ Main Content ################ */}
            <CustomCard2 title={'Products perfomance'} height={640}>
                <Grid container spacing={2} justifyContent="center">
                    <Grid item sm={12}>
                        <ProductBranchesTable />
                    </Grid>
                    <Grid item sm={12}>
                        <Box sx={{ textAlign: 'center' }}>
                            <Button
                                startIcon={<Add />}
                                className="app-btn"
                                variant="contained"
                                onClick={() => {
                                    let title = 'Add product on-sell';
                                    let content = 'addOnSell';
                                    handleOpenDialogy(title, content);
                                }}
                            >
                                Add stock
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                <Box
                    sx={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}
                >
                    <Grid container justifyContent={'center'}>
                        <Grid item sm={12}>
                            <Box
                                sx={{
                                    background: `linear-gradient(180deg, ${colors.bgColor4}, ${colors.bgColor1})`,
                                    borderRadius: 2,
                                    py: 2,
                                    color: colors.primary,
                                }}
                            >
                                <Typography
                                    sx={{
                                        textAlign: 'center',
                                        py: 1,
                                        fontWeight: 'bold',
                                    }}
                                >
                                    General stats
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        mt: 0.5,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: '100%',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: 12,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            In-stock
                                        </Typography>
                                        <Typography sx={{ fontSize: 13 }}>
                                            {inStockCount}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            textAlign: 'center',
                                            borderLeft: '1px solid green',
                                            borderRight: '1px solid green',
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: 12,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Sold
                                        </Typography>
                                        <Typography sx={{ fontSize: 13 }}>
                                            {soldCount}
                                        </Typography>
                                    </Box>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: 12,
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            Total sells
                                        </Typography>
                                        <Typography sx={{ fontSize: 13 }}>
                                            {numberWithCommas(totalSells)}{' '}
                                            <sup>TZS</sup>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </CustomCard2>
        </>
    );
};

export default ProductDetailsSidebar;
